import { Component } from '@angular/core';
import * as registrationStrings from "../stringFiles/registration.json";
import { commonFunctionService } from '../utils/commonFunctions';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
declare var $: any;
@Component({
  selector: 'app-logout-modal',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './logout-modal.component.html',
  styleUrl: './logout-modal.component.css'
})
export class LogoutModalComponent {
  strings: any;
  constructor(private commonFunction: commonFunctionService, private translate: TranslateService) {
    this.strings = registrationStrings
  }
  logout() {
    $('#logout').modal('hide');
    // Preserve the chosen display language across logout — it's a device/
    // browser preference, not part of the session.
    const savedLang = localStorage.getItem('lang');
    localStorage.clear();
    if (savedLang) {
      localStorage.setItem('lang', savedLang);
    }
    this.deleteCookiesBasedOnURL();
    const backdrops = document.getElementsByClassName('modal-backdrop');
    while (backdrops.length > 0) {
      backdrops[0].parentNode.removeChild(backdrops[0]);
    }
    window.location.href = "/#/login"
  }

  deleteCookiesBasedOnURL() {
    if (window.location.hostname.split('.')[1] === 'localhost') {
      this.commonFunction.deleteAllLocalCookies();
    } else {
      this.commonFunction.deleteAllCookies();
    }
  }

}
